export default "__VITE_ASSET__D4wb9wsZ__"